import React from "react";
import DashboardLayout from "../dashboard/layout/DashboardLayout";
import { useAuth } from "../../../supabase/auth";
import { Navigate } from "react-router-dom";
import { LoadingScreen } from "../ui/loading-spinner";
import CallLogsList from "../callLogs/CallLogsList";

const CallLogsPage: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingScreen text="Loading..." />;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <DashboardLayout
      activeItem="Call Logs"
      title="Call Logs"
      description="View and manage your call history"
    >
      <CallLogsList />
    </DashboardLayout>
  );
};

export default CallLogsPage;
